import React from "react";
import { Box, Collapse, Divider, Paper, Stack, Typography } from "@mui/material";
import { AppGroup } from "../../utils/types";

type SelectedGroupDetailsProps = {
  group: AppGroup;
  top: number;
  minHeight: number;
  minWidth?: number;
};

export function SelectedGroupDetails({
  group,
  top,
  minHeight,
  minWidth = 900,
}: SelectedGroupDetailsProps) {
  const responsible = group.participants.find((participant) => participant.isResponsible);

  return (
    <Box
      sx={{
        position: "absolute",
        top,
        left: 0,
        right: 0,
        width: "100%",
        minWidth,
        pb: 1,
      }}
    >
      <Collapse in timeout="auto" unmountOnExit>
        <>
          <Paper variant="elevation" elevation={0} sx={{ p: 2, minHeight, width: "100%", border: "none" }}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
              Detalhes do grupo selecionado
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Stack spacing={0.75} sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>ID:</strong> {group.id}
              </Typography>
              <Typography variant="body2">
                <strong>Criado por:</strong> {group.createdBy || "Nao informado"}
              </Typography>
              <Typography variant="body2">
                <strong>Responsavel:</strong> {responsible?.name || "Nao informado"}
              </Typography>
              <Typography variant="body2">
                <strong>Telefone responsavel:</strong> {responsible?.phone || "Nao informado"}
              </Typography>
              <Typography variant="body2">
                <strong>Descricao:</strong> {group.description || "Nao informada"}
              </Typography>
              <Typography variant="body2">
                <strong>Local de reuniao:</strong> {group.meetingLocation.address || "Nao informado"}
                {group.meetingLocation.number ? `, ${group.meetingLocation.number}` : ""}
                {group.meetingLocation.neighborhood ? ` - ${group.meetingLocation.neighborhood}` : ""}
                {group.meetingLocation.complement ? ` (${group.meetingLocation.complement})` : ""}
              </Typography>
            </Stack>

            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
              Participantes ({group.participants.length})
            </Typography>

            {group.participants.length > 0 ? (
              <Stack spacing={0.5}>
                {group.participants.map((participant, index) => (
                  <Typography variant="body2" key={`${group.id}-participant-${index}`}>
                    {participant.isResponsible ? "[Responsavel] " : ""}
                    {participant.name} - {participant.phone}
                  </Typography>
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Nenhum participante cadastrado.
              </Typography>
            )}
          </Paper>
          <Box component="hr" sx={{ border: 0, borderTop: "1px solid", borderColor: "divider", m: 0 }} />
        </>
      </Collapse>
    </Box>
  );
}

export default SelectedGroupDetails;
